<div class="page">

  <!-- En-tête -->
  <div class="page-header">
    <div>
      <h1 class="page-title">Activités</h1>
      <p class="page-subtitle">Gestion et suivi de toutes les activités</p>
    </div>
  </div>

  <!-- Barre d'outils : boutons + filtres -->
  <div class="toolbar" [formGroup]="generaleForm">

    <!-- Section gauche : boutons d'action -->
    <div class="toolbar-actions">
      <app-ui-button
        label="Ajouter"
        variant="primary"
        iconLeft="add_circle_outline"
        [routerLink]="routealias.activities.activity.add"
      />

      <app-ui-button
        *ngIf="hasAccess(['SU', 'RA'])"
        label="Regrouper"
        variant="secondary"
        iconLeft="category"
        [routerLink]="[
          '/',
          routealias.activities.home,
          routealias.activities.activity.home,
          routealias.activities.activity.regroupement_activity.home,
          routealias.activities.activity.regroupement_activity.add
        ]"
      />
    </div>

    <!-- Section droite : filtres -->
<!-- Section droite : filtres -->
<div class="toolbar-filters">
  <app-select
    formControlName="typeCodeSelect"
    [options]="types"
    [loading]="loadingtypeSelect"
    placeholder="Type"
  />
  <app-select
    formControlName="interventionSelect"
    [options]="resultatStructures"
    [loading]="loadinginterventionSelect"
    [placeholder]="getTypeLabel()"
  />
</div>

  </div>

  <!-- Contenu : loader ou table -->
  <div class="content-card">
    @if (isLoading) {
      <div>
        <app-loaderIntervantion baseColor="rgba(14,14,18,0.1)" />
      </div>
    } @else {
      <app-ui-table
        [columns]="tableActivities"
        [data]="activitiesFiltre"
        [actions]="rowActions"
      />
    }
  </div>

</div>

<!-- Template actions par ligne -->
<ng-template #rowActions let-item="item" let-index="index">
  <div class="row-actions">
    <app-ui-button
      iconOnly="edit"
      variant="ghost"
      size="sm"
      ariaLabel="Modifier"
      [routerLink]="getEditRouterLink(item)"
      (clicked)="null"
    />
    <app-ui-button
      iconOnly="delete"
      variant="danger"
      size="sm"
      ariaLabel="Supprimer"
      (clicked)="openDeleteDialog(item)"
    />
  </div>
</ng-template>

<!-- Boîte de confirmation de suppression -->
<app-confirm-dialog
  [isVisible]="showDeleteDialog"
  title="Supprimer l'activité"
  message="Cette action est irréversible. L'activité sera définitivement supprimée."
  [itemLabel]="itemToDelete?.titre ?? itemToDelete?.name ?? ''"
  confirmLabel="Supprimer"
  cancelLabel="Annuler"
  [isLoading]="isDeleteLoading"
  (confirmed)="onDeleteConfirmed()"
  (cancelled)="closeDeleteDialog()"
/>